
export default {
  name: "Empty",
  middleware: ["isActive"],
  props: ["error"],
};
